<div class="modal-container">
    <div class="modal-header">
        <h2 class="title">Manage Brand Visibility</h2>
        <p class="subtitle">Choose the brands you want to see insights for</p>
    </div>

    <div class="search-container">
        <div class="search-input-wrapper">
            <input type="text" placeholder="Search" [(ngModel)]="searchTerm" (ngModelChange)="searchTerm.set($event)">
            <img class='search-icon' src="svg/search-gray.svg">
        </div>
    </div>

    <div class="selection-status">
        Showing {{selectedCount()}} of {{allBrands().length}} brands
    </div>
    <div class="brand-list">
        @for (brand of filteredBrands(); track brand.key; let last = $last) {
        <div class="brand-item" [class.last]="last">
            <div class="brand-info">
                <div class="brand-logo-wrapper">
                    <img [src]="brand.icon" class="brand-logo">
                </div>
                <span class="brand-name-label">{{brand.label}}</span>
            </div>
            <app-toggle-switch [enabled]="isBrandVisible(brand.key)"
                (toggled)="onToggleBrand(brand, $event)"></app-toggle-switch>
        </div>
        }
    </div>
    <div class="modal-footer">
        <app-button text="Cancel" class="secondary" (clicked)="cancel()"></app-button>
        <app-button text="Save Changes" class="primary" (clicked)="save()"></app-button>
    </div>
</div>
